import { ORIENTATION } from 'lib/constants/orientation';
import cookie from './cookie';

export const isiOS = (): boolean => {
  const ua = navigator.userAgent;
  return /iphone|ipod|ipad|Mac OS X/i.test(ua) || !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

export const isQQBrowser = (): boolean => {
  const ua = navigator.userAgent;
  return ua.indexOf('MQQBrowser') > -1 || !!ua.match(/QQ\/([\d.]+)/);
};

// 当前环境处于 iOS QQ 内（sendBeacon 在此环境下会丢 body，上报需降级走 axios）
export const iniOSQQ = (): boolean => isiOS() && isQQBrowser();

export const isValidURL = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const isPC = (): boolean => {
  if (isiOS()) return false;
  return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
};

export const isVertical = (): boolean => !!window.matchMedia('(orientation: portrait)').matches;

export const isLandscape = (): boolean => !!window.matchMedia('(orientation: landscape)').matches;

export const getOrientation = (): number => {
  if (isLandscape()) return ORIENTATION.LANDSCAPE;
  if (isVertical()) return ORIENTATION.VERTICAL;
  return ORIENTATION.UNKNOWN;
};

export const getStatisticParams = (): string =>
  JSON.stringify({
    page_key: cookie.get('page_hash') || window?.VISION?.meta?.actKey,
    orientation: getOrientation(),
  });
